// import moment from 'moment';
import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchTaskDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'task/dropdown';
  
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}


export function saveTask(app, dataToSave) {
  const { user = {}, data } = dataToSave;

  const taskData = {
    doc_type: DocType.TASK,
    subsidiary_id: util.toStringText(data.subsidiary_id),
    location_id: util.toStringText(data.location_id),
    effective_date: util.toUtcDate(data.effective_date),
    due_date: util.toUtcDate(data.due_date),
    task_type_id: util.toStringText(data.task_type_id),
    name: util.toStringText(data.name),
    description: util.toStringText(data.description),
    task_priority: util.toStringText(data.task_priority),
    assignees: util.toObjectIds(
      data.assignees,
      data.assignees_ids,
      'assignee_id',
    ),
    parent_id: util.toStringText(data.parent_id),
    percentage_complete: util.toNumber(data.percentage_complete),
    close_reason_code_id: util.toStringText(data.close_reason_code_id),
    close_comment: util.toStringText(data.close_comment),
    attachments: data.attachments || [],
    active: util.toBoolean(data.active),
  };
  

  if (100 >= taskData.percentage_complete && taskData.percentage_complete >= 0) {
    if (taskData.percentage_complete !== 100) {
      taskData.close_reason_code_id = null;
      taskData.close_comment = null;
    }
  }

  taskData.attachments = taskData.attachments.map( note => {

    if (!note.attachment) {
      note.attachment = null;
    }

    note.created_datetime = util.toUtcDate(note.created_datetime);
    return note;
  })

  return common.saveDoc(app, {
    source: data,
    doc: taskData,
    user
  });
}

export function fetchTaskById(app, params) {
  const { id } = params;
  const docType = DocType.TASK;
  return common.getDoc(app, { id, docType });
}

export function deleteTask (app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.TASK
  });
}
